import axios from "../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/xgw/AXgwVideo/index", {
        params: {
            ...params
        }
    } )
}
function ADD_DATA(params) {
    return  axios.get("/xgw/AXgwVideo/add",{
        params: {}
    } )
}
function EDIT_DATA(params) {
    return  axios.get("/xgw/AXgwVideo/edit",{params:{id:params}}

      )
}
function SUBMIT_ADD(params) {
    return  axios.post("/xgw/AXgwVideo/addPost",{...params} )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/xgw/AXgwVideo/editPost",{...params} )
}


function CHANG_STATUS (params) {
    return  axios.post("/xgw/AXgwVideo/statusEdit",{status:params} )
}
function DELE(params) {
    return  axios.get("/xgw/AXgwVideo/delete",{
        params: {
            ids:params
        }
    } )
}
function LIST_ORDER (params) {
    return  axios.post("/xgw/AXgwVideo/listOrder",{list_orders:params} )
}
export default {
    GET_LIST,
    ADD_DATA,
    EDIT_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    CHANG_STATUS,
    DELE,
    LIST_ORDER
}